import Nav from "../general/navbar.jsx";

const MentionsLegales = () => {
  return (
    <section id="mentions-legales" className="service-details">
      <Nav />
      <div className="container">
        <div className="content">
          <div className="col-xl-8 col-lg-7">
            <div className="service-details__right">
              <div className="service-details__content">
                <h3 className="service-details__content-title">
                  Mentions Legales
                </h3>

                <p className="service-details__text-1">
                  La connexion et la navigation sur le Site par l’Utilisateur
                  implique acceptation intégrale et sans réserve des présentes
                  mentions légales.
                  <br />
                  Ces dernières sont accessibles sur le site{" "}
                  <strong>www.up4mind.com</strong> à la rubrique « Mentions
                  légales ».
                </p>

                {/* Article 1 */}
                <p className="service-details__text-2 title-primary">
                  1. Présentation du site
                </p>
                <p className="service-details__text-3">
                  En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004
                  pour la confiance dans l’économie numérique (LCEN), il est
                  précisé aux utilisateurs du site{" "}
                  <strong>www.up4mind.com</strong> l’identité des intervenants :
                  <ul>
                    <li>
                      Société <strong>UP4MIND</strong> au capital
                      <strong> 1 000 € </strong>, immatriculée au RCS de{" "}
                      <strong>NICE</strong> sous le SIREN :{" "}
                      <strong>942 598 160</strong>, dont le siège social est
                      situé au{" "}
                      <strong>58 CORNICHE FLEURIE, 06000 NICE France</strong>
                    </li>
                    <li>
                      Responsable de publication :{" "}
                      <strong>Maël COLONNESE</strong>
                    </li>
                    <li>
                      Hébergeur : <strong> OVH SAS</strong>, capital
                      <strong>10 000 000 euros</strong>, situé au{" "}
                      <strong>2, Rue Kellermann 59100 Roubaix</strong>
                    </li>
                  </ul>
                </p>

                {/* Article 2 */}
                <p className="service-details__text-2 title-secondary">
                  2. Informations nominatives
                </p>
                <p className="service-details__text-3">
                  Conformément à la réglementation (loi « Informatique et
                  Libertés »), vous disposez d’un droit d’accès, de
                  rectification et d’opposition. Vous pouvez exercer ces droits
                  en ligne via{" "}
                  <a href="/contact" className="link">
                    cette page
                  </a>{" "}
                  ou par courrier postal à l’adresse mentionnée ci-dessus.
                </p>

                {/* Article 3 */}
                <p className="service-details__text-2 title-third">
                  3. Conditions générales d’utilisation
                </p>
                <p className="service-details__text-3">
                  L’utilisation du site <strong>www.up4mind.com</strong> suppose
                  l’acceptation pleine et entière des conditions d’utilisation,
                  susceptibles d’évoluer. Les utilisateurs sont invités à les
                  consulter régulièrement.
                </p>
                <p className="service-details__text-3">
                  Ce site est normalement accessible à tout moment, sauf
                  maintenance. En cas d’intervention, les dates et horaires vous
                  seront préalablement communiqués.
                </p>
                <p className="service-details__text-3">
                  Le site <strong>www.up4mind.com</strong> est mis à jour
                  régulièrement. Les mentions légales peuvent être modifiées à
                  tout moment ; l’utilisateur est invité à les consulter
                  fréquemment.
                </p>

                {/* Article 4 */}
                <p className="service-details__text-2 title-fourth">
                  4. Description des services fournis
                </p>
                <p className="service-details__text-3">
                  Le site <strong>www.up4mind.com</strong> a pour objet de
                  fournir des informations sur l’ensemble des activités de
                  l’entreprise.
                </p>
                <p className="service-details__text-3">
                  L’entreprise <strong>UP4MIND</strong> s’efforce d’y fournir
                  des données précises. Toutefois, elle ne pourra être tenue
                  responsable des omissions ou inexactitudes.
                </p>
                <p className="service-details__text-3">
                  Les informations sont données à titre indicatif et peuvent
                  être modifiées à tout moment.
                </p>

                {/* Article 5 */}
                <p className="service-details__text-2 title-primary">
                  5. Limitations techniques
                </p>
                <p className="service-details__text-3">
                  Le site utilise la technologie JavaScript. L’entreprise ne
                  pourra être tenue responsable des dommages matériels liés à
                  son utilisation. L’utilisateur doit disposer d’un matériel
                  moderne, sans virus, et d’un navigateur à jour.
                </p>

                {/* Article 6 */}
                <p className="service-details__text-2 title-secondary">
                  6. Propriété intellectuelle
                </p>
                <p className="service-details__text-3">
                  L’entreprise <strong>UP4MIND</strong> est propriétaire des
                  droits de propriété intellectuelle ou détient les droits
                  d’usage sur tous les éléments du site (textes, images, logos,
                  logiciels). Plusieurs images sont issues de Pexels.
                </p>
                <p className="service-details__text-3">
                  Toute reproduction, représentation, modification, publication
                  ou adaptation est interdite sans autorisation écrite
                  préalable.
                </p>
                <p className="service-details__text-3">
                  Toute exploitation non autorisée sera poursuivie selon les
                  articles L.335-2 et suivants du Code de Propriété
                  Intellectuelle.
                </p>

                {/* Article 7 */}
                <p className="service-details__text-2 title-third">
                  7. Responsabilité
                </p>
                <p className="service-details__text-3">
                  L’entreprise <strong>UP4MIND</strong> ne pourra être tenue
                  responsable des dommages directs ou indirects liés à l’accès
                  au site.
                </p>
                <p className="service-details__text-3">
                  Des espaces interactifs (contact) sont à la disposition des
                  utilisateurs. L’entreprise se réserve le droit de supprimer
                  tout contenu non conforme sans préavis.
                </p>
                <p className="service-details__text-3">
                  En cas de message illicite (raciste, injurieux, diffamatoire,
                  pornographique…), la responsabilité civile ou pénale de
                  l’utilisateur pourra être engagée.
                </p>

                {/* Article 8 */}
                <p className="service-details__text-2 title-fourth">
                  8. Données personnelles
                </p>
                <p className="service-details__text-3">
                  Les données personnelles sont protégées par les lois n° 78-17
                  du 6 janvier 1978, n° 2004-801 du 6 août 2004 et la Directive
                  Européenne du 24 octobre 1995. Elles peuvent être collectées :
                  URL d’accès, fournisseur d’accès, adresse IP. L’utilisateur
                  peut exercer ses droits selon la loi « Informatique et
                  Libertés ».
                </p>

                {/* Article 9 */}
                <p className="service-details__text-2 title-primary">
                  9. Cookies et liens hypertextes
                </p>
                <p className="service-details__text-3">
                  La navigation sur le site <strong>www.up4mind.com</strong>{" "}
                  peut installer des cookies. Un cookie est un fichier de petite
                  taille enregistrant des informations de navigation. Le refus
                  de cookies peut empêcher l’accès à certains services.
                </p>
                <p className="service-details__text-3">
                  L’utilisateur peut configurer son navigateur pour bloquer les
                  cookies :
                  <ul>
                    <li>
                      <strong>Internet Explorer :</strong> Outils → Options
                      Internet → Confidentialité → Bloquer les cookies.
                    </li>
                    <li>
                      <strong>Firefox :</strong> Menu Firefox → Options → Vie
                      privée → Paramètres personnalisés → Désactiver les
                      cookies.
                    </li>
                    <li>
                      <strong>Safari :</strong> Réglages → Avancées →
                      Confidentialité → Paramètres de contenu → Bloquer les
                      cookies.
                    </li>
                    <li>
                      <strong>Chrome :</strong> Menu → Paramètres → Avancés →
                      Confidentialité → Préférences → Bloquer les cookies.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MentionsLegales;
